import React from 'react';

/**
 * Componente Spinner moderno y profesional
 * 
 * @param {string} size - Tamaño del spinner: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} overlay - Si debe mostrarse con overlay de fondo (default: false)
 * @param {string} message - Mensaje opcional a mostrar debajo del spinner
 */
const Spinner = ({ size = 'medium', overlay = false, message = '' }) => {
  const sizeClass = `spinner-${size}`;
  
  if (overlay) {
    return (
      <div className="spinner-overlay-fullscreen">
        <div className="spinner-container">
          <div className={`modern-spinner ${sizeClass}`}>
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
            <div className="spinner-circle"></div>
          </div>
          {message && <p className="spinner-message">{message}</p>}
        </div>
      </div>
    );
  }
  
  return (
    <div className="spinner-container">
      <div className={`modern-spinner ${sizeClass}`}>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
      </div>
      {message && <p className="spinner-message">{message}</p>}
    </div>
  );
};

export default Spinner;

